// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"AddNewUser_modalWrapper__36gCg","elementWrapper":"AddNewUser_elementWrapper__R5n4C","error":"AddNewUser_error__3YYDt"};